import {Component, OnInit, ViewChild} from '@angular/core';
import { PoolsService } from '../../../services/configuration/pools.service';
import {WfTableComponent} from '../../../common/table-sort/wf-table.component';
import {GenericModalService} from '../../../services/generic-modal.service';
import {PoolsModalComponent} from './pools-modal/pools-modal.component';
import {AdminService} from '../../../services/admin.service';
import {BusinessProcessService} from '../../../services/business-process.service';
import {error} from 'selenium-webdriver';

@Component({
  selector: 'app-pools',
  templateUrl: './pools.component.html',
  styleUrls: ['./pools.component.css']
})
export class PoolsComponent implements OnInit {

  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;
  hasPoolRight = false;
  hasConfigSystemParams = false; // 4194304
  hasConfigureMyMetadata = false; // 16777216

  errorMessage = '';
  pleaseWait = false;
  isOnInit = true;
  successMessage = '';
  filteredPools = [];
  availablePools = [];
  filterSettings = {
    placeholder: 'Filtrar',
    width: 100,
    inputTextSearchId: 'txtSearchGlobalVariable',
    showBooleanFilter: false,
    textFilterPropertyName: 'name',
  };
  editPoolModalComponent: any = PoolsModalComponent;

  constructor(private poolsService: PoolsService, private modalService: GenericModalService, private admService: AdminService,
              private bpService: BusinessProcessService) { }

  ngOnInit() {
    this.checkRight(4194304);
    this.checkRight(16777216);
  }

  getAll() {
    this.errorMessage = '';
    this.pleaseWait = true;

    this.poolsService.getAll().subscribe(result => {
      this.filteredPools = result;
      this.availablePools = result;
      this.pleaseWait = false;
    }, error1 => {
      this.pleaseWait = false;
      this.errorMessage = error1;
    });
  }

  onCreateOrUpdatePool(pool: any = null) {
    let title = 'Novo';
    let objInitialState = {};
    if (pool == null) {
      objInitialState = { poolId: 0 };
    } else {
      title = 'Editar';
      delete pool['extensionData'];
      objInitialState = pool;
    }
    const result$ = this.modalService.showObjModal(this.editPoolModalComponent, `${title} Pool`, objInitialState);
    if (result$) {
      result$.asObservable()
        .subscribe(
          result => {
            if (result) {
              this.ngOnInit();
            }
          }
        );
    } else {
      this.errorMessage = 'Sessão expirada.';
    }
  }

  onDeletePool(pool: any) {
    this.errorMessage = '';
    delete pool['extensionData'];
    let message =
      `Confirma a exclusão de <b>${pool.name}?</b> <br> <br>`;
    message = message.concat(`Isto causará a desassociação de seus usuários participantes e, consequentemente, os metadados configurados
    para o pool deixarão de ter efeito durante a aplicação da regra de distribuição de instâncias.`);
    let alert: any;
    alert = this.modalService.showConfirmModal('Aviso de exclusão', message);
    alert.then( resp => {
      if (resp.value) {
        this.poolsService.deletePool(pool)
          .subscribe( () => {
            this.successMessage = `Pool ${pool.name} excluído com sucesso.`;
            this.ngOnInit();
            setTimeout(() => {
              this.successMessage = '';
            }, 2000);
          },
          error1 => {
            this.errorMessage = error1;
          });
      }
    });
  }

  onFilterList(filteredData: any[]) {
    this.filteredPools = filteredData;
  }

  checkRight(item: number) {
    this.errorMessage = '';
    this.bpService.checkRights(item).subscribe(right => {
      this.isOnInit = false;
      switch (item) {
        case 4194304:
          this.hasConfigSystemParams = right.length > 0;
          if (this.hasConfigSystemParams) {
            this.getAll();
          }
          break;
        case 16777216:
          this.hasConfigureMyMetadata = right.length > 0;
          break;
      }
    }, error1 => {
      this.errorMessage = error1;
    });
  }
}
